module.exports = __webpack_public_path__ + "img/signature-sample-bg.797caf4c.png";